import ControleOrders from './ControleOrders';

export default ControleOrders;
